import React, { useEffect } from "react";
import LearnersCreating from "../../../../components/Insights/StoriesSnapShot/LearnersCreating";
import HowTheyLearning from "../../../../components/Insights/StoriesSnapShot/HowTheyLearning";
import HowTheyDoing from "../../../../components/Insights/StoriesSnapShot/HowTheyDoing";
import SchoolWork from "../../../../components/Insights/SchoolWork/SchoolWork";
import { useDashboardFeed } from "../../../../hooks/useSchoolFeed";
import { useMetrics } from "../../../../hooks/useMetrics";

function SchoolView({ data }: { data: any }) {
  const schoolHash = data?.schoolHash;

  const { data: feedData,loading:feedLoading,fetchMoreFeed, refetch: dashBoardFetch } = useDashboardFeed({
    feedScopeType: "school",
    schoolHash,
    enabled: !!schoolHash,
  });

 

  const {
    data: metricsData,
    loading: mLoading,
    refetch: matricsfetch,
  } = useMetrics({
    scope: "school",
    schoolHash,
    range: data?.range,
    enabled: !!schoolHash,
  });

  // useEffect(() => {
  //     if (schoolHash) {
  //       dashBoardFetch();
  //       matricsfetch();
  //     }
  //   },[data?.range]);

  return (
    <div>
      <LearnersCreating loading={mLoading} classroomData={metricsData} />
      <HowTheyDoing loading={mLoading} data={metricsData} />
      {/* <HowTheyLearning loading={mLoading} name="nathon" learningData={data} /> */}
      <SchoolWork title="Your School's Work" loading={feedLoading} fetchMoreFeed={fetchMoreFeed} feedData={feedData} showGrade />
    </div>
  );
}

export default SchoolView;
